$.fn.InfiniteScroll = function(options) {
  let self = this

  self.options = $.extend(true, {
    onLoad: undefined,
  }, options)

  self.first_article = self.find('main[data-next-url]')
  self.last_article = self.first_article
  self.articles = self.first_article
  self.current_article = self.first_article
  self.next_url = self.last_article.data('next-url')
  self.is_popping = false

  if (self.data('infinite-scroll')) {
    return self.data('infinite-scroll')
  }

  self.load_next = function(url) {
    $.get(url, function(x) {
      let loadedArticle =  $('<html>').html(x).find('main[data-next-url]')
      self.next_url = loadedArticle.data('next-url')
      self.last_article.after(loadedArticle)
      self.last_article = loadedArticle
      self.articles = $('main[data-url]')
      if (self.options.onLoad != undefined) {
        self.options.onLoad(loadedArticle)
      }
    })
  }

  self.scrolled = function(top) {
    let currentArticle = self.first_article
    self.articles.each(function(index, el) {
      if (top > $(el).offset().top - $(window).height() / 2) {
        currentArticle = $(el)
      }
    })
    if (self.current_article.data('url') != currentArticle.data('url')) {
      self.current_article = currentArticle
      if ('history' in window) {
        if (self.is_popping) {
          self.is_popping = false
        } else {
          document.title = self.current_article.data('title')
          if (location.hostname != 'localhost') {
            history.pushState({
              infiniteScroll: true,
              infiniteScrollURL: self.current_article.data('url'),
              infiniteScrollTitle: self.current_article.data('title'),
            }, '', self.current_article.data('url'))
          }
        }
      }
      if (!$('main[data-url="' + self.next_url + '"]').length) {
        self.load_next(self.next_url)
      }
    }
  }

  return function() {
    if ('history' in window) {
      if (location.hostname != 'localhost') {
        history.scrollRestoration = 'manual'
        history.replaceState({
          infiniteScroll: true,
          infiniteScrollURL: self.current_article.data('url'),
          infiniteScrollTitle: self.current_article.data('title'),
        }, '', self.first_article.data('url'))
      }
      $(window).ScrollEvents().add(self.scrolled)
      self.load_next(self.next_url)
      $(window).on('popstate', function(e) {
        let popState = e.originalEvent.state
        if (popState != null && 'infiniteScroll' in popState && popState.infiniteScroll) {
          let target = $('main[data-url="' + popState.infiniteScrollURL + '"]')
          if (target.length) {
            e.preventDefault()
            self.is_popping = true
            document.title = popState.infiniteScrollTitle
            $('html, body').scrollTo(target.offset().top, 350, 4, 'easeInOutQuart')
          }
        }
      })
    }
    self.data('infinite-scroll', self)
    return self
  }()
}
